import React, { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import {
	Box,
	ClickAwayListener,
	FormLabel,
	Grid,
	Grow,
	InputAdornment,
	Paper,
	Popper,
	Slider,
	Switch,
	TextField,
	Typography,
	withStyles,
	Tooltip,
	Collapse,
	Badge,
	Fade,
	Chip,
	IconButton,
} from '@material-ui/core';
// import '../Goals/OkrListing/style.scss';
import {
	abbreviateNumber,
	getCurrencyIcon,
	getOkrProgressDetails,
	getTime,
	getUserDetails,
	formatNumberWithCommas,
	getPercentage,
	getValueFromPercentage,
	getPercentageOfKr,
	getMetricFullValue,
	getPercentageUpperValue,
	confidenceIcon,
	getCurrencyName,
	getFullName,
	getTargetValueFormated,
} from '../../../config/utils';
import clapAnim from '../../../images/clapAnim.svg';
import { Enums } from '../../../config/enums';
import { NumbersIcon, PercentageIcon } from '../../../config/svg/MyGoalSvg';
import _ from 'lodash';
import { NumberFormatComponent } from '../../Common/NumberFormat';
import { getLocalStorageItem, setLocalStorageItem } from '../../../services/StorageService';
import { OKRButton } from '../../Common/OKRButton';
import { CancelIcon, TickIcon } from '../../../config/svg/Action';
import { KrConfidence } from '../../Common/KrConfidence';
import CkEditor from '../../Common/CkEditor/CkEditor';
import { progressRemovePlugin } from '../../Common/CkEditor/CkEditorEnums';
import { dragDisabled } from '../../../action/myGoal';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AvatarUser } from '../../Common/User/AvatarUser';
import { KpiProgressBar } from './KpiProgressBar';
import { AlignNewArrow, LeftArrow } from '../../../config/svg/ArrowSvg';
import { ClapIcon, KebabIcon } from '../../../config/svg/CommonSvg';
import { AnimatedIcon } from '../../Common/AnimatedIcon';

export const KpiProgressBarMain: React.FC<any> = (props) => {
	const {
		loginUserAvatar,
		okr,
		kr,
		updateProgress,
		showEditLoader,
		currentUser,
		kpiUser,
		okrMasterData,
		showArchiveList,
		enqueueSnackbar,
		setOpenKrId,
		isScoreLocked,
		parentOkr,
		newKr = false,
		isEditable = true,
		classNames = '',
		setErrorOpen,
		errorOpen,
		kpiDataList,
	} = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [openProgressDetail, setOpenProgressDetail] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	let scoreValue = kr?.myScore ? kr?.myScore : 0;
	const [progressValuePercentage, setProgressValuePercentage] = useState<any>(kr?.myScore);
	const [popperError, setPopperError] = useState(false);

	useEffect(() => {
		dispatch(dragDisabled(openProgressDetail ? (kr.id ? kr.id : kr.goalKeyId) : 0));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [openProgressDetail]);
	const handleToggle = (e: any) => {
		if (!errorOpen) {
			setAnchorEl(anchorEl ? null : e.currentTarget);
			setOpenProgressDetail((previousOpen: any) => !previousOpen);
		}
	};
	const handleClose = (event: any) => {
		event.preventDefault();
		event.stopPropagation();
		if (!isProgressUpdated) {
			setAnchorEl(null);
			setOpenProgressDetail(false);
			setPopperError(false);
			setIsProgressUpdated(false);
		} else {
			setPopperError(true);
		}
	};

	const [progressValue, setProgressValue] = useState<any>(scoreValue);
	const [isProgressUpdated, setIsProgressUpdated] = useState<boolean>(false);
	const [isReset, setIsReset] = useState<boolean>(false);
	const [scoreInNumber, setScoreInNumber] = useState<any>(0);
	let currentYear = getLocalStorageItem('currentYear');
	useEffect(() => {
		if (anchorEl !== null) {
			if (kr?.isScored) {
				setScoreInNumber(kr?.currentValue);
			} else {
				setScoreInNumber('');
			}

			let percentage: any;
			if (kr?.startValue === 0 && kr?.targetValue === 0) {
				percentage = getPercentageOfKr(kr?.startValue, kr?.currentValue, kr?.targetValue);
			} else {
				percentage = getPercentageOfKr(kr?.startValue, kr?.currentValue, kr?.targetValue);
			}
			setProgressValuePercentage(loginUserAvatar.score);
			setProgressValue(loginUserAvatar.score);
			setOpenKrId(kr.goalKeyId);
			setIsProgressUpdated(false);
			setErrorOpen(false);
			setPopperError(false);
		} else {
			setOpenKrId(0);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [anchorEl]);

	const resetProgress = () => {
		setIsReset(true);
		setScoreInNumber(kr?.currentValue);

		let percentage: any;
		if (kr?.startValue === 0 && kr?.targetValue === 0) {
			percentage = getPercentageOfKr(kr?.startValue, kr?.currentValue, kr?.targetValue);
		} else {
			percentage = getPercentageOfKr(kr?.startValue, kr?.currentValue, kr?.targetValue);
		}
		setProgressValuePercentage(Math.floor(Number(percentage)));
		setProgressValue(Number(percentage) < 0 ? 0 : Number(percentage));
		setIsProgressUpdated(false);
		setErrorOpen(false);
	};

	const handleFieldChange = (newValue: any) => {
		let assignmentTypeId = kr.assignmentTypeId;
		if (Boolean(parentOkr) && Boolean(parentOkr.goalObjectiveId)) {
			assignmentTypeId = parentOkr.assignmentTypeId;
		}
		const regexp = /^[0-9\\.b]+$/;
		if (newValue === '' || regexp.test(newValue)) {
			newValue = !Boolean(newValue) ? '' : newValue;
			// setProgressValue(newValue);
			if (!isReset) {
				setIsProgressUpdated(true);
				setErrorOpen(true);
			} else {
				setIsReset(false);
			}
			setScoreInNumber(newValue);
			let score: any = 0;
			let percentage: any = 0;
			if (kr.targetValue || kr.startValue) {
				if (kr?.startValue === 0 && kr?.targetValue === 0) {
					score = getPercentageOfKr(kr?.startValue, newValue, kr?.targetValue);
					percentage = getPercentageOfKr(kr?.startValue, newValue, kr?.targetValue);
				} else {
					score = getPercentageOfKr(kr.startValue, newValue, kr.targetValue);
					percentage = getPercentageOfKr(kr.startValue, newValue, kr.targetValue);
				}
				setProgressValuePercentage(Math.floor(Number(percentage)));
				setProgressValue(score < 0 ? 0 : score);
				setPopperError(false);
			}
		}
	};

	const handleSliderChange = (event: any, newValue: number | number[]) => {
		let assignmentTypeId = kr.assignmentTypeId;
		if (Boolean(parentOkr) && Boolean(parentOkr.goalObjectiveId)) {
			assignmentTypeId = parentOkr.assignmentTypeId;
		}
		let score: any = getValueFromPercentage(kr.targetValue, newValue, kr.startValue, kr.currentValue);
		let percentage: any = getPercentageOfKr(kr.startValue, score, kr.targetValue);
		if (Number(score) === 0) {
			setScoreInNumber(0);
		} else {
			setScoreInNumber(score);
		}
		setProgressValuePercentage(Math.floor(Number(percentage)));
		setIsProgressUpdated(true);
		setErrorOpen(true);
	};

	const saveProgress = () => {
		let assignmentTypeId = kr.assignmentTypeId;
		if (Boolean(parentOkr) && Boolean(parentOkr.goalObjectiveId)) {
			assignmentTypeId = parentOkr.assignmentTypeId;
		}
		if (parseFloat(kr.currentValue) !== parseFloat(scoreInNumber) || !kr?.isScored) {
			setAnchorEl(null);
			setOpenProgressDetail(false);
			setIsProgressUpdated(false);
			setErrorOpen(false);
			updateProgress(kr.goalKeyId || kr.krId, assignmentTypeId, scoreInNumber || 0, currentYear, parentOkr);
		}
	};
	const editAllowed = () => {
		return !kpiDataList.isScoreLocked && currentUser?.employeeId === kpiUser?.employeeId && kr.isProgressAllowed; // && !isTeamView;
	};
	const handlePopperScroll = (event: any, elementId: any) => {
		setTimeout(function () {
			let element = document.getElementById(elementId);
			if (element) {
				element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
			}
		}, 100);
	};

	return (
		<Box className={`okr-list-progressbar ${classNames ? classNames : ''}`} style={{ width: '100%' }}>
			<div
				className={`okr-list-progressbar-inner ${openProgressDetail ? 'progressbar-active' : ''}`}
				onClick={(e: any) => {
					handleToggle(e);
					handlePopperScroll(e, `kr-popper-progress-detail-${kr.goalKeyId || kr.krId}`);
				}}
				id={`okr-progress-${kr.goalKeyId || kr.krId}`}
			>
				<Box className={`okr-list-progress-head `}>
					<Box className='progress-bar-section'>
						<Box className='progress-slider'>
							<KpiProgressBar
								{...props}
								parentOkr={okr}
								okr={{ ...kr, score: kr.score }}
								type={'kr'}
								t={t}
								updateProgress={updateProgress}
								showEditLoader={showEditLoader}
								currentUser={currentUser}
								okrMasterData={okrMasterData}
								showArchiveList={showArchiveList}
								isScoreLocked={isScoreLocked}
								enqueueSnackbar={enqueueSnackbar}
								isAnyDrawerOpened={props.isAnyDrawerOpened}
								appDrawerInfo={props.appDrawerInfo}
								drawerOpen={openProgressDetail}
								newKr={newKr}
							/>
						</Box>
					</Box>
					<Box className='progress-accordion-arrow'>
						<OKRButton className='accordion-icon' icon={<LeftArrow />} />
					</Box>
				</Box>
			</div>
			{openProgressDetail && (
				<Popper
					open={openProgressDetail}
					anchorEl={anchorEl}
					placement='bottom'
					transition
					className={`popper-okr-progress-bar ${
						parentOkr.goalStatusId === Enums.GOAL_STATUS_DRAFT || showArchiveList || props.newKr
							? 'popper-progress-new-kr'
							: ''
					}`}
					modifiers={{
						preventOverflow: {
							enabled: false,
							boundariesElement: window,
						},

						flip: {
							enabled: false, // true by default
						},
					}}
					id={`kr-popper-progress-detail-${kr.goalKeyId || kr.krId}`}
					container={anchorEl}
				>
					{({ TransitionProps }) => (
						<Fade {...TransitionProps}>
							<Paper>
								<ClickAwayListener onClickAway={handleClose}>
									<Box>
										<Box className={`progress-contributor-list`}>
											<Box
												// className={`progress-contributor-row ${
												// 	!currentUser && isEditable
												// 		? 'progress-parent-row'
												// 		: 'contributor-list-info contributor-list-info-first'
												// } `}
												className={`progress-contributor-row`}
											>
												<Box className='progress-contributor-left'>
													{/* add deleted-user class for deleted user */}
													<Box
														className={`${
															loginUserAvatar.isActive === false
																? 'progress-contributor-info deleted-user'
																: 'progress-contributor-info'
														}`}
													>
														<Box className='user-info'>
															<Box className='user-img'>
																<AvatarUser userDetail={kpiUser} className='contributor-owner' />
															</Box>
															<Box className='user-info-details'>
																<Tooltip title={getFullName(kpiUser)} arrow>
																	<Typography variant='body1' className='user-name'>
																		{getFullName(kpiUser)}
																	</Typography>
																</Tooltip>
																{kpiUser.isActive === false && <Chip className='delete-chip' label={t('Deleted')} />}
															</Box>
														</Box>
													</Box>
													{/* add deleted-user class for deleted user */}
													<Box
														className={`${
															kpiUser.isActive === false
																? 'progress-contributor-progress deleted-user'
																: 'progress-contributor-progress'
														}`}
													>
														<Box className='progress-contributor-progress-inner'>
															<Box className='popup-progress-box'>
																<Box className='popup-progress-track'>
																	{!(!loginUserAvatar?.targetValue && !loginUserAvatar?.startValue) ? (
																		<Box className='popup-progress-value'>
																			<Typography variant='h6'>
																				{getTargetValueFormated(
																					loginUserAvatar?.startValue,
																					kr?.metricId,
																					kr?.currencyId,
																					props.okrMasterData
																				)}
																			</Typography>
																			<Typography variant='h6'>
																				{getTargetValueFormated(
																					loginUserAvatar?.targetValue,
																					kr?.metricId,
																					kr?.currencyId,
																					props.okrMasterData
																				)}
																			</Typography>
																		</Box>
																	) : (
																		<Box className='popup-progress-value'>
																			<Typography variant='h6'>Target not set</Typography>
																		</Box>
																	)}
																	<Box className='popup-progress-rail'>
																		<Slider
																			aria-label={t('MyGoalProgressSlider')}
																			//style={{ color }}
																			value={progressValue}
																			disabled={kr?.targetValue === 0}
																			min={0}
																			max={100}
																			className={'show-blue-slider'}
																			onChange={(e, val) => {
																				if (editAllowed()) {
																					setProgressValue(val);
																					handleSliderChange(e, val);
																				}
																			}}
																		/>
																	</Box>
																</Box>
																{!(!loginUserAvatar?.targetValue && !loginUserAvatar?.startValue) ? (
																	<Typography variant='h6'>
																		{!isEditable
																			? getPercentageUpperValue(loginUserAvatar.score)
																			: editAllowed()
																			? getPercentageUpperValue(progressValuePercentage)
																			: getPercentageUpperValue(loginUserAvatar.score)}
																		{'%'}
																	</Typography>
																) : (
																	<Typography variant='h6'>--</Typography>
																)}
															</Box>
															<Box className='progress-input-area'>
																{!loginUserAvatar?.targetValue && !loginUserAvatar?.startValue ? (
																	<Box className='popup-progress-value-bottom'>
																		<Typography variant='h6'></Typography>
																	</Box>
																) : editAllowed() ? (
																	<Box className={`progress-input-box ${isProgressUpdated ? 'action-btn-show' : ''}`}>
																		<TextField
																			placeholder={kr.metricId === 2 ? '100' : '100'}
																			className={`${popperError ? 'progress-input-unsaved' : ''}`}
																			value={scoreInNumber}
																			inputProps={{
																				maxLength: Enums.MAX_LENGTH_CURRENT_TARGET,
																				inputType: 'numberFieldProgress',
																			}}
																			onChange={(e: any) => {
																				handleFieldChange(e.target.value);
																			}}
																			name='percentage'
																			InputProps={{
																				inputComponent: NumberFormatComponent,
																				startAdornment: (
																					<InputAdornment position='start'>
																						{kr.metricId === 1
																							? '%'
																							: kr.metricId === 2
																							? getCurrencyIcon(
																									getCurrencyName(kr?.metricId, kr?.currencyId, props.okrMasterData)
																							  )
																							: '#'}
																					</InputAdornment>
																				),
																			}}
																		/>
																		{isProgressUpdated && (
																			<Box className='textfield-action-btn'>
																				<OKRButton
																					className='cancel-btn'
																					id={'cancel-btn'}
																					icon={<CancelIcon />}
																					handleClick={() => resetProgress()}
																				/>
																				<OKRButton
																					className='save-btn'
																					id={'save-btn'}
																					icon={<TickIcon />}
																					disabled={!isProgressUpdated}
																					handleClick={(e: any) => {
																						saveProgress();
																					}}
																				/>
																			</Box>
																		)}
																	</Box>
																) : (
																	<Box className='popup-progress-value-bottom'>
																		{isEditable && (
																			<Typography variant='h6'>
																				{kr?.metricId !== Enums.ONE &&
																					getTargetValueFormated(
																						loginUserAvatar?.currentValue,
																						kr?.metricId,
																						kr?.currencyId,
																						props.okrMasterData
																					)}
																			</Typography>
																		)}
																	</Box>
																)}
																{isEditable && !(!loginUserAvatar?.targetValue && !loginUserAvatar?.startValue) && (
																	<Box className='progress-link-icon'></Box>
																)}
															</Box>
														</Box>

														{/* Target not set */}

														<Box className='progress-kebab-icon'></Box>
													</Box>
												</Box>
												<Box className='progress-contributor-right'>
													<Typography variant='h5'>
														{0 && !loginUserAvatar?.targetValue && !loginUserAvatar?.startValue
															? '--'
															: kr?.metricId === Enums.ONE
															? '--'
															: loginUserAvatar.actualContribution
															? getPercentageUpperValue(loginUserAvatar.actualContribution) + '%'
															: 0 + '%'}
													</Typography>
												</Box>
											</Box>
										</Box>
									</Box>
								</ClickAwayListener>
							</Paper>
						</Fade>
					)}
				</Popper>
			)}
		</Box>
	);
};
